import { render } from "./Checkbox.vue?vue&type=template&id=71aa438a&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=71aa438a&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aa438a"]])

export default __exports__